"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTEGRATION_EVENT_NAME = void 0;
exports.dispatchIntegrationEvent = dispatchIntegrationEvent;
var _dispatchCustomEvent = require("./dispatchCustomEvent");
/**
 * The standardized name for all integration events.
 * DO NOT LISTEN TO THIS NAME DIRECTLY.
 * Instead, create and listen to business events.
 */
const INTEGRATION_EVENT_NAME = exports.INTEGRATION_EVENT_NAME = 'ori-integration';

/**
 * The structure of the detail property for integration events.
 * DO NOT USE THIS DIRECTLY, USE BUSINESS EVENTS INSTEAD.
 */

/**
 * See [docs](https://oriflame.visualstudio.com/FrontendPlatform/_wiki/wikis/Front-end/13022/Events) for a list of possible param types of each user action event.
 */

/**
 * Creates an integration event with a standardized name and detail structure.
 * @param name The specific name of the integration event.
 * @param detail The data associated with the integration event.
 * @returns A new CustomEvent instance with the standardized integration event structure.
 */
function createIntegrationEvent(name, detail) {
  // the name of all integration events is 'ori-integration-data'
  // the actual event name is inside of the `detail.name` property
  return new CustomEvent(INTEGRATION_EVENT_NAME, {
    detail: {
      ...detail,
      name
    }
  });
}
function createUserActionEvent(name, data) {
  return createIntegrationEvent('user-action', {
    dataSlots: [name, ...data]
  });
}

/**
 * Dispatches an integration event with the specified name and data.
 *
 * When data is an array, it creates a user-action event. See [docs](https://oriflame.visualstudio.com/FrontendPlatform/_wiki/wikis/Front-end/13022/Events) for a list of possible param types of each user action event.
 * @param name The specific name of the integration event.
 * @param params The data associated with the integration event.
 */

function dispatchIntegrationEvent(name, params) {
  if (Array.isArray(params)) {
    (0, _dispatchCustomEvent.dispatchCustomEvent)(createUserActionEvent(name, params));
  } else {
    (0, _dispatchCustomEvent.dispatchCustomEvent)(createIntegrationEvent(name, params));
  }
}
//# sourceMappingURL=dispatchIntegrationEvent.js.map